import { useUnit } from 'effector-react'
import { environment } from '../constants'
import { $premiumLevel } from '@/entities/user'
import { PremiumLevel } from '@/entities/user'

export function useGetLastTimeForCooldown({
  nextUpdateDate,
  kind,
}: {
  nextUpdateDate: string | null | undefined
  kind: 'scoring' | 'claim' | 'bonus'
}) {
  const premiumLevel = useUnit($premiumLevel)

  if (!nextUpdateDate) return new Date()
  const PT30S = 30 * 1000
  const PT60S = 60 * 1000
  // const TWO_MINUTES = 120 * 1000
  const PT24H = 24 * 60 * 60 * 1000
  const PT12H = 12 * 60 * 60 * 1000

  /*
  STEAM__MIN_UPDATE_PLATINUM_INTERVAL=PT12H
  STEAM__MIN_UPDATE_INTERVAL=PT24H
  STEAM__MIN_UPDATE_PREMIUM_INTERVAL=PT24H
  */
  const nextUpd = new Date(nextUpdateDate)
  if (environment === 'dev') {
    if (kind == 'scoring') {
      if (premiumLevel === PremiumLevel.PLATINUM) return new Date(nextUpd.getTime() - PT30S)
      if (premiumLevel === PremiumLevel.PLUS) return new Date(nextUpd.getTime() - PT60S)
      if (premiumLevel === PremiumLevel.UNSUBSCRIBED) return new Date(nextUpd.getTime() - PT60S)
    }
  } else {
    if (kind == 'scoring') {
      if (premiumLevel === PremiumLevel.PLATINUM) return new Date(nextUpd.getTime() - PT12H)
      if (premiumLevel === PremiumLevel.PLUS) return new Date(nextUpd.getTime() - PT24H)
      if (premiumLevel === PremiumLevel.UNSUBSCRIBED) return new Date(nextUpd.getTime() - PT24H)
    }
  }
  return nextUpd
}
